module.exports = __webpack_public_path__ + "img/tips7.cb68f683.png";